<template>
  <portal-target name="file-drawer">
    <q-toolbar class="q-pl-sm sticky-position blurred-container">
      <q-btn
        flat
        round
        icon="mdi-close"
        @click="$emit('close')"
      />
      <page-toolbar-title class="q-pl-sm">
        File Details
      </page-toolbar-title>

      <help-button filter="files" />
    </q-toolbar>
    <q-list
      dense
      padding
    >
      <detail-item
        large
        icon="mdi-rename-box"
        name="Title"
      >
        <q-input
          v-model="file.title"
          placeholder="Enter Title"
          outlined
          autogrow
          dense
          :error="!!errors['title']"
          :error-message="errors['title'] ? errors['title'][0] : null"
          :disable="!isAllowedEditing || saving"
          @keydown.enter="$event.preventDefault()"
          @keyup.enter="performSave"
        />
      </detail-item>
      <detail-item
        large
        icon="mdi-text"
        name="Description"
      >
        <q-input
          v-model="file.description"
          type="textarea"
          placeholder="Enter Description"
          outlined
          dense
          :error="!!errors['description']"
          :error-message="errors['description'] ? errors['description'][0] : null"
          :disable="!isAllowedEditing"
        />
      </detail-item>
      <detail-item
        icon="mdi-folder-outline"
        large
        name="Category"
      >
        <CatSelect
          v-model="file.category_id"
          outlined
          dense
          behavior="menu"
          :disable="!isAllowedEditing"
          :error="!!errors['category_id']"
          :error-message="errors['category_id'] ? errors['category_id'][0] : null"
        />
      </detail-item>
      <detail-item
        large
        name="File Visibility"
        :icon="file.visibility === 'EVERYONE' ? 'mdi-eye' : 'mdi-eye-off'"
      >
        <q-option-group
          v-model="file.visibility"
          :options="getVisiblityOptions(file.user)"
          :disable="!isAllowedEditing"
          :error="!!errors['visibility']"
          :error-message="errors['visibility'] ? errors['visibility'][0] : null"
        />
        <transition name="slideTransition">
          <page-banner
            v-if="file.visibility === 'MYSELF'"
            dense
            color="blue-grey-1"
            class="q-mt-sm"
            caption="File may be visible to other staff if it is attached to an item such as an Activity Timeline"
          />
        </transition>
      </detail-item>

      <q-toolbar v-if="isAllowedEditing">
        <q-space />
        <portal-target name="file-buttons" />
        <q-btn
          size="12px"
          color="green"
          :loading="saving"
          class="q-ml-sm"
          icon-right="done"
          label="Save"
          @click="performSave"
        />
      </q-toolbar>

      <!-- Storage Details -->
      <q-item-label
        header
        class="text-bold q-mt-lg"
      >
        Storage Details
      </q-item-label>
      <detail-item
        large
        icon="mdi-link-variant"
        name="File Name"
        :value="file.file_name"
      />
      <detail-item
        large
        :icon="getIcon(file.file_extension)"
        name="File Type"
        :value="file.file_extension.toUpperCase()"
      />
      <detail-item
        large
        icon="mdi-weight"
        name="File Size"
        :value="getFilesize(file.total_file_size)"
      />
      <portal-target name="file-storage" />
      <q-separator
        inset
        class="q-my-sm"
      />
      <detail-item
        v-if="!!file.attachments_count"
        :name-spacing="100"
        icon="mdi-paperclip"
        name="Attached To"
        large
        :value="file.attachments_count + ' items'"
      />
      <detail-item
        large
        icon="mdi-content-duplicate"
        name="Created On"
      >
        <q-item-label>{{ $formatSystemDate(file.created_at, luxonFormats.FRIENDLY_DATE_TIME) }}</q-item-label>
        <q-item-label
          v-if="file.user"
          caption
        >
          By {{ file.user.name }}
        </q-item-label>
      </detail-item>
    </q-list>
  </portal-target>
</template>

<script>
import fileMixin from '../../mixins/fileMixin'
import CatSelect from 'components/app/files/partials/categories/CatSelect.vue'

export default {
  components: {
    CatSelect
  },
  mixins: [fileMixin],
  props: {
    file: {
      type: Object,
      required: true
    },
    errors: {
      type: Object,
      default: () => {
        return {}
      }
    },
    saving: {
      type: Boolean,
      default: false
    },
    isAllowedEditing: {
      type: Boolean,
      default: false
    }
  },
  emits: ['close', 'saveFile'],
  methods: {
    performSave () {
      this.$emit('saveFile')
    }
  }
}
</script>
